import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { Check, Delete, List, MoreVert, PictureAsPdf } from '@mui/icons-material';
import { ListItemIcon, ListSubheader } from '@mui/material';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function GroupPageMenu({ handlePdf, setShowNotPresent, setShowEmpty, showNotPresent, showEmpty, }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const clickPdf = (p) => {
        handleClose()
        handlePdf(p)

    }


    return (
        <div>
            <Button
                id="cow-button"
                aria-controls={open ? 'cow-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant={open ? 'contained' : "outlined"}
                disableElevation
                onClick={handleClick}

            >
                <MoreVert />
            </Button>
            <StyledMenu
                id="cow-menu"
                MenuListProps={{
                    'aria-labelledby': 'cow-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <ListSubheader>stampa PDF</ListSubheader>
                <MenuItem onClick={() => clickPdf('complete')} disableRipple>
                    <ListItemIcon>
                        <PictureAsPdf />
                    </ListItemIcon>
                    Liste soggetti complete
                </MenuItem>
                <MenuItem onClick={() => clickPdf('catalog')} disableRipple>
                    <ListItemIcon>
                        <PictureAsPdf />
                    </ListItemIcon>
                    Liste codice catalog soggetti
                </MenuItem>
                <MenuItem onClick={() => clickPdf('summary')} disableRipple>
                    <ListItemIcon>
                        <PictureAsPdf />
                    </ListItemIcon>
                    Solo intestazioni
                </MenuItem>
                <Divider />
                <ListSubheader>opzioni visualizzazione liste</ListSubheader>
                <MenuItem onClick={() => { setShowNotPresent(true); handleClose() }} disableRipple sx={showNotPresent === true && { backgroundColor: 'lightblue' }}>
                    <ListItemIcon>
                        {showNotPresent === true &&
                            <Check />
                        }
                    </ListItemIcon>
                    visualizza soggetti non presenti
                </MenuItem>
                <MenuItem onClick={() => { setShowNotPresent(false); handleClose() }} disableRipple sx={showNotPresent === false && { backgroundColor: 'lightblue' }}>
                    <ListItemIcon>
                        {showNotPresent === false &&
                            <Check />
                        }
                    </ListItemIcon>
                    nascondi soggetti non presenti
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => { setShowEmpty(true); handleClose() }} disableRipple sx={showEmpty === true && { backgroundColor: 'lightblue' }}>
                    <ListItemIcon>
                        {showEmpty === true &&
                            <Check />
                        }
                    </ListItemIcon>
                    visualizza liste vuote
                </MenuItem>
                <MenuItem onClick={() => { setShowEmpty(false); handleClose() }} disableRipple sx={showEmpty === false && { backgroundColor: 'lightblue' }}>
                    <ListItemIcon>
                        {showEmpty === false &&
                            <Check />
                        }
                    </ListItemIcon>
                    nascondi liste vuote
                </MenuItem>
            </StyledMenu>
        </div>
    );
}